import './AppointedRequests.css';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Form from 'react-bootstrap/Form';
import AppointedRequestsRow from '../AppointedRequestsRow/AppointedRequestsRow';
import {QuestionCircle} from 'react-bootstrap-icons';

function AppointedRequests(props){
     const dispatch = useDispatch();
        const request = useSelector((store) => store.requestReducer.appointments);
    const requestNewest = useSelector((store) => store.requestNewestReducer.appointments);
    const requestName = useSelector((store) => store.requestNameReducer.appointments);
    const [searchTerm, setSearchTerm ] = useState("");
    const [searchResults,setSearchResult] = useState([]);
    const inputEl = useRef("");
          const searchHandler = (searchTerm) =>{
        setSearchTerm(searchTerm);
        if(searchTerm !==""){
            const newClientList = request.filter((request)=>{
              return Object.values(request).join(" ").toLowerCase().includes(searchTerm.toLowerCase());
            })
            setSearchResult(newClientList);
            console.log("test"+searchResults);
        }
        else{
            setSearchResult(request);
             console.log("test"+searchResults);
        }
        }

    const getSearchTerm = () =>{
      
        searchHandler(inputEl.current.value);
    }

      useEffect(() => {
       

  
  }, []);
    return(
        <>
               <input ref={inputEl} size="40" type="text" value={searchTerm} onChange={getSearchTerm} placeholder="type to search"></input> <button onClick ={(e) => (setSearchTerm(""))} >CLEAR</button>
        <Table striped bordered hover>
            <thead>
                <tr>
                    <th className="text-center">
                        Appointment Date
                    </th>
                    <th className="text-center">
                        Client Name
                    </th>
                    <th className="text-center">
                        Requested Items
                    </th>
                    <th className="text-center">
                        Actions
                    </th>
                </tr>
            </thead>
                        {searchTerm.length<1?
            <>
            {props.sortValue == 0 ?
            <AppointedRequestsRow searchResults = {requestNewest}/>
            :
            <>
                {props.sortValue == 1 ?
                    <AppointedRequestsRow searchResults = {request}/>
                    :
                    <>
                        {props.sortValue == 2?
                        <AppointedRequestsRow searchResults = {requestName}/>
                            :
                            <> </> 
                        }
                    </>
                }
            </>
            }

            </>
            :
             <AppointedRequestsRow
            
             searchResults = {searchResults}
        
             
             />
            
            }
        </Table>
        </>
    );

}

export default AppointedRequests;